module.exports = __webpack_public_path__ + "img/Frame_ItemFrame01_Color_Brown.e06dbcc7.png";